export const ESCOPO_VAZIO = {
  tipo: "zona",
  skus: [],
  colecao: null,
  // A tela chama "categoria" tanto a coleção do ERP quanto a categoria do
  // catálogo Ouran (decisão 2026-09-18) — modoOuran diz qual das duas
  // `colecao` referencia, pra montarEscopos mandar a chave certa pro back.
  modoOuran: false,
  exclusoes: [],
  mecanica: null,
};

export const OPCOES_DE_ESCOPO = [
  { value: "zona", label: "Zona" },
  { value: "sku", label: "SKUs" },
  { value: "colecao", label: "Categoria" },
];

const doTipo = (escopos, tipo, exclusao) =>
  escopos.filter(
    (escopo) =>
      escopo.scope_type === tipo && Boolean(escopo.is_exclusion) === exclusao
  );

export const montarEscopos = (escopo) => {
  if (escopo.tipo === "sku") {
    return escopo.skus.map((produto) => ({
      scope_type: "sku",
      produto,
      is_exclusion: false,
    }));
  }
  if (escopo.tipo === "colecao") {
    return [
      {
        scope_type: "collection",
        ...(escopo.modoOuran
          ? { ouran_category: escopo.colecao }
          : { collection: escopo.colecao }),
        is_exclusion: false,
      },
      ...escopo.exclusoes.map((produto) => ({
        scope_type: "sku",
        produto,
        is_exclusion: true,
      })),
    ];
  }
  return [];
};

export const erroDoEscopo = (escopo) => {
  if (escopo.tipo === "sku" && escopo.skus.length === 0) {
    return "Selecione ao menos um SKU.";
  }
  if (escopo.tipo === "colecao" && !escopo.colecao) {
    return "Selecione a categoria.";
  }
  return null;
};

export const estadoDoEscopo = (evento) => {
  const escopos = Array.isArray(evento?.scopes) ? evento.scopes : [];
  const mecanica = evento?.mechanic ?? null;
  const [colecao] = doTipo(escopos, "collection", false);
  if (colecao) {
    const modoOuran = colecao.ouran_category != null;
    return {
      ...ESCOPO_VAZIO,
      tipo: "colecao",
      colecao: modoOuran ? colecao.ouran_category : colecao.collection,
      modoOuran,
      exclusoes: doTipo(escopos, "sku", true).map((item) => item.produto),
      mecanica,
    };
  }
  const skus = doTipo(escopos, "sku", false).map((item) => item.produto);
  if (skus.length > 0) {
    return { ...ESCOPO_VAZIO, tipo: "sku", skus, mecanica };
  }
  return { ...ESCOPO_VAZIO, mecanica };
};

export const escopoEditavel = (evento) => {
  if (!evento || evento.origem === "erp") return false;
  const escopos = Array.isArray(evento.scopes) ? evento.scopes : [];
  const zonas = escopos.filter((escopo) => escopo.scope_type === "zone");
  const deProduto = escopos.length - zonas.length;
  const colecoes = doTipo(escopos, "collection", false).length;
  const skus = doTipo(escopos, "sku", false).length;
  if (deProduto > 0 && zonas.length > 0) return false;
  if (colecoes > 1) return false;
  if (colecoes === 1 && skus > 0) return false;
  return true;
};

const plural = (quantidade, singular, varios) =>
  `${quantidade} ${quantidade === 1 ? singular : varios}`;

export const resumoDoEscopo = (evento) => {
  const escopos = Array.isArray(evento?.scopes) ? evento.scopes : [];
  const colecoes = doTipo(escopos, "collection", false).map(
    (escopo) =>
      escopo.ouran_category_description ||
      escopo.collection_description ||
      `#${escopo.collection ?? escopo.ouran_category}`
  );
  const excecoes = doTipo(escopos, "sku", true).length;
  const skus = doTipo(escopos, "sku", false).length;
  const zonas = escopos.filter((escopo) => escopo.scope_type === "zone").length;
  const partes = [];
  if (colecoes.length > 0) {
    partes.push(
      `Categoria ${colecoes.join(", ")}${
        excecoes ? ` exceto ${plural(excecoes, "SKU", "SKUs")}` : ""
      }`
    );
  }
  if (skus > 0) partes.push(plural(skus, "SKU", "SKUs"));
  if (zonas > 0) partes.push(plural(zonas, "zona", "zonas"));
  return partes.length > 0 ? partes.join(" + ") : "Zona";
};
